import React, { useState, useEffect } from "react";
import { useTheme } from "../components/ThemeContext";
import {
  Form,
  Button,
  Row,
  Col,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import "../App.css";
import NavMenu from "../components/NavMenu";
import axios from "axios";
import { useParams } from "react-router-dom";
import TextareaAutosize from "react-textarea-autosize";
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function EditAppraisal() {
  const [step, setStep] = useState(1);
  const [selectedValue, setSelectedValue] = useState("Select role");
  const [roles, setRoles] = useState([]);
  const { role_id } = useParams();
  const { isDark } = useTheme();

  const navigate = useNavigate();

  const [factors, setFactors] = useState([
    { factor: "", description: "", rating: "" },
    { factor: "", description: "", rating: "" },
    { factor: "", description: "", rating: "" },
  ]);

  const [performances, setPerformances] = useState([
    { description: "", score: "", rating: "" },
    { description: "", score: "", rating: "" },
    { description: "", score: "", rating: "" },
  ]);

  const handleSelectRole = (eventKey) => {
    const selectedRole = roles.find(
      (role) => String(role.role_id) === String(eventKey)
    );

    setSelectedValue(selectedRole?.roles || "gg");
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

        const response = await axios.get(
          process.env.REACT_APP_API + `/getRoles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setRoles(response.data.data);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (err) {
        console.error("Failed to fetch tags:", err);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    if (role_id && roles.length > 0) {
      fetchDetailTemplate(role_id);
      const selectedRole = roles.find(
        (r) => String(r.role_id) === String(role_id)
      );
      setSelectedValue(selectedRole?.roles || "Select role");
    }
  }, [role_id, roles]);

  const fetchDetailTemplate = async (roleId) => {
    try {
       const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getDetailTemplate`,
        {
          params: { role_id: roleId },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        const data = response.data.data;

        const factorItems = data.filter((item) => item.factor !== null);
        const performanceItems = data.filter((item) => item.factor === null);

        setFactors(
          factorItems.map((item) => ({
            factor: item.factor || "",
            description: item.description || "",
            rating: item.default_rating_scale || "",
          }))
        );

        setPerformances(
          performanceItems.map((item) => ({
            description: item.description || "",
            score: item.weight || "",
            rating: item.default_rating_scale || "",
          }))
        );
      } else {
        console.error("Error fetching template detail:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading detail template:", error);
    }
  };

  const addFactor = () => {
    setFactors([...factors, { factor: "", description: "", rating: "" }]);
  };

  const addPerformance = () => {
    setPerformances([
      ...performances,
      { description: "", score: "", rating: "" },
    ]);
  };

  const handleFactorChange = (index, field, value) => {
    const updated = [...factors];
    updated[index][field] = value;
    setFactors(updated);
  };

  const handlePerformanceChange = (index, field, value) => {
    const updated = [...performances];
    updated[index][field] = value;
    setPerformances(updated);
  };

  const saveTemplate = async () => {
    const selectedRole = roles.find((r) => r.roles === selectedValue);
    if (!selectedRole) {
      alert("Please select a valid role.");
      return;
    }

    const role_id = selectedRole.role_id;

    // Simple validation
    if (factors.length === 0 || performances.length === 0) {
      alert("Please add at least one factor and one performance.");
      return;
    }

    try {
       const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

      const response = await axios.post(
        `${process.env.REACT_APP_API}/saveTemplate`,
        {
          role_id,
          factors,
          performances,
        },
        {
         headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        alert("Template saved successfully!");
        setStep(1);
        setSelectedValue("Select role");
        setFactors([
          { factor: "", description: "", rating: "" },
          { factor: "", description: "", rating: "" },
          { factor: "", description: "", rating: "" },
        ]);
        setPerformances([
          { description: "", score: "", rating: "" },
          { description: "", score: "", rating: "" },
          { description: "", score: "", rating: "" },
        ]);
      } else {
        alert("Failed to save template. Please try again.");
      }
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Server error. Please try again later.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <NavMenu />
      <div className={`p-4 ${isDark ? "text-light" : "text-dark"}`}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="header-title mb-0">
            <Button
              variant={isDark ? "outline-dark" : "outline-light"}
              size="sm"
              onClick={handleBack}
              style={{
                fontSize: "0.9rem",
                color: "#B31E8D",
                border: isDark ? "1px solid #202020" : "1px solid #EAECF0",
              }}
            >
              <IoArrowBackSharp
                style={{
                  marginRight: "5px",
                  color: isDark ? "#fff" : "#B31E8D",
                }}
                size={20}
              />
            </Button>{" "}
            Edit Appraisal Management{" "}
          </h5>

          <div className="d-flex align-items-center">
            <p className="mb-0 me-2">Template For:</p>
            <DropdownButton
              title={selectedValue || "Select tags"}
              onSelect={handleSelectRole}
              variant={isDark ? "dark" : "outline-dark"}
              disabled
            >
              {Array.isArray(roles) && roles.length > 0 ? (
                roles.map((role) => (
                  <Dropdown.Item key={role.role_id} eventKey={role.role_id}>
                    {role.roles}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No Roles available</Dropdown.Item>
              )}
            </DropdownButton>
          </div>
        </div>

        <div className="stepper mb-4 d-flex align-items-center gap-2">
          {[1, 2, 3].map((num) => (
            <React.Fragment key={num}>
              <div
                className={`step ${step === num ? "active" : ""} ${
                  isDark ? "step-dark" : "step-light"
                }`}
                onClick={() => setStep(num)}
                style={{ cursor: "pointer" }}
              >
                {num}
              </div>
              {num < 3 && (
                <div
                  className={`line ${isDark ? "line-dark" : "line-light"}`}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        {step === 1 && (
          <>
            <p className="fw-semibold">Part I: COMPETENCIES</p>
            <Row>
              <Col md={3}>
                <p>Factor</p>
              </Col>
              <Col md={6}>
                <p>Description</p>
              </Col>
              <Col md={3}>
                <p>Rating</p>
              </Col>
            </Row>
            {factors.map((factor, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={3}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder={`Factor #${idx + 1}`}
                    value={factor.factor}
                    onChange={(e) =>
                      handleFactorChange(idx, "factor", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={6}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Description"
                    value={factor.description}
                    onChange={(e) =>
                      handleFactorChange(idx, "description", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Form.Select
                    value={factor.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handleFactorChange(idx, "rating", e.target.value)
                    }
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col>
              </Row>
            ))}
            <div className="d-flex gap-3 mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addFactor}
              >
                Add Factor
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setStep(2)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <p className="fw-semibold">
              Part II: SPECIFIC PERFORMANCE OBJECTIVES
            </p>
            <Row>
              <Col md={7}>
                <p>Description of Work Targets and Actual Results Attained</p>
              </Col>
              <Col md={2}>
                <p>Weight</p>
              </Col>
              <Col md={3}>
                <p>Rating</p>
              </Col>
            </Row>
            {performances.map((perf, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={7}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Key Objectives"
                    value={perf.description}
                    onChange={(e) =>
                      handlePerformanceChange(
                        idx,
                        "description",
                        e.target.value
                      )
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Form.Select
                    value={perf.score}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handlePerformanceChange(idx, "score", e.target.value)
                    }
                  >
                    <option>Weight</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </Form.Select>
                </Col>
                <Col md={3}>
                  <Form.Select
                    value={perf.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handlePerformanceChange(idx, "rating", e.target.value)
                    }
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col>
              </Row>
            ))}
            <div className="d-flex gap-3 mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addPerformance}
              >
                Add New Performance
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setStep(3)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <p className="fw-semibold">Part III: OVERALL ASSESSMENT</p>
            <p className="fw-semibold">Summary of Ratings</p>
            <p>Overall Rating For Part I & Part II</p>

            <Row className="mb-4">
              <Col md={3}>
                {[
                  "EXCELLENT",
                  "VERY GOOD",
                  "GOOD",
                  "SATISFACTORY",
                  "BELOW AVERAGE",
                  "POOR",
                ].map((label, i) => (
                  <p key={i} className="fw-semibold">
                    {label}
                  </p>
                ))}
              </Col>
              <Col md={2}>
                {[
                  "4.5 to 5.0",
                  "4.0 to 4.49",
                  "3.5 to 3.99",
                  "3.0 to 3.49",
                  "2.5 to 2.99",
                  "< 2.5",
                ].map((score, i) => (
                  <p key={i} className="fw-semibold">
                    {score}
                  </p>
                ))}
              </Col>
              <Col md={7}>
                <p className="text-secondary small">
                  Excellent performance, well exceeded expectations. For
                  recruiters who exceed 120% of quota.
                </p>
                <p className="text-secondary small">
                  Very good performance and consistently exceed expectations.
                  For recruiters who exceed 100% -119% of quota.
                </p>
                <p className="text-secondary small">
                  Good performance and exceed expectations in many areas. For
                  recruiters who exceed 85% - 100% of quota.
                </p>
                <p className="text-secondary small">
                  Satisfactory performance, meet basic expectations and need
                  some supervision. For recruiters who achieved between 70-84%
                  of quota.
                </p>
                <p className="text-secondary small">
                  Below average performance. Needs supervision in their work.
                  Warrant P-I-P if performance remains below average for 2
                  consecutive quarters. Recruiters who meet 50% - 69% of quota.
                </p>
                <p className="text-secondary small">
                  Poor performance. Need improvement and a lot of supervision in
                  all work areas. Warrant P-I-P. Recruiters who achieved less
                  than 50% of quota for more than 2 consecutive quarters.
                </p>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{
                  background: "#B31E8D",
                  width: "200px",
                  height: "50px",
                }}
                onClick={saveTemplate}
              >
                Save Template
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default EditAppraisal;
